import React, { useCallback, useState } from 'react'
import { useRequest } from 'ahooks'
import Panel from '@/components/Panel'
import { Area } from '@ant-design/charts'
import { GetPaymentServiceStatisticsTrend,GetPaymentServiceStatisticsChannel } from '@/services/api'
import style from './style.module.scss'
import { Spin } from 'antd'
import ImgSource from '@/assets/img/jingying/shoururiqishi@2x.png'
import { chartDataFill } from '@/utils/chart'

interface PayModeServerInfo {
  bills: number;
  dayWeek: string;
  date: string;
}

interface PayModeData {
  payModeLabel: string;
  payModeServerInfos: PayModeServerInfo[];
}

interface ChartData {
  date: string;
  bills: number;
  payModeLabel: string;
}

export interface ParkingDailyIncomeProps {
  areaCode?: string
}

const ParkingDailyIncome: React.FC<ParkingDailyIncomeProps> = ({ areaCode }) => {
  const [lotchangModal, setLotchangModal] = useState(true)
  const lotchangdata = (val: boolean) => {
    setLotchangModal(val)
  }

  const { data:roadData = [], loading, error } = useRequest(
    useCallback(() => {
      return GetPaymentServiceStatisticsChannel({areaCode})
    }, [areaCode]),
    {
      formatResult: (res) => {
        // 转换数据结构
        return (res.data as PayModeData[]).flatMap((item: PayModeData) => 
          item.payModeServerInfos.map((info: PayModeServerInfo) => ({
            date: (info.date).split('-')[1] + '-' + (info.date).split('-')[2],
            bills: info.bills,
            payModeLabel: item.payModeLabel
          }))
        );
      },
      refreshDeps: [areaCode],
    },
  )
  const { data:parkData = [], loading:parkLoading, error:parkError } = useRequest(
    useCallback(() => {
      return GetPaymentServiceStatisticsTrend({areaCode})
    }, [areaCode]),
    {
      formatResult: (res) => {
        // 转换数据结构
        return res.data.map((info:any) => ({
            date: (info.date).split('-')[1] + '-' + (info.date).split('-')[2],
            billAmount: info.billAmount,
          }))
        
      },
      refreshDeps: [areaCode],
    },
  )
  console.log(parkData,roadData);
  
  const data = lotchangModal ? roadData : parkData
  if (loading ) {
    return (
      <Panel title='支付服务统计'>
        <div className='fetch_container' style={{ height: 200 }}>
          <Spin />
        </div>
      </Panel>
    )
  }

  if (error) {
    return (
      <Panel title='支付服务统计'>
        <div className='fetch_container' style={{ height: 200 }}>
          请求错误
        </div>
      </Panel>
    )
  }

  return (
    <Panel title='支付服务统计'>
      <div className={style.parkinglotmore} onClick={()=>lotchangdata(!lotchangModal)}>切换{lotchangModal ? '渠道占比' : '订单统计'}</div>
      {data?.length > 0 ? (
        <Area
          height={200}
          padding={[20, 20, 23, 48]}
          smooth={true}
          data={data}
          xField='date'
          yField={lotchangModal ? 'bills' : 'billAmount'}
          seriesField={lotchangModal ? 'payModeLabel' : undefined}
          startOnZero={false}
          legend={false}
          xAxis={{
            label: {
              style: {
                fill: '#fff',
              },
            },
            line: {
              style: {
                stroke: '#12708D',
              },
            },
            tickLine: null,
            range: [0, 1],
          }}
          yAxis={{
            label: {
              style: {
                fill: '#fff',
              },
              formatter: (v) => `${v}`,
            },
            line: {
              style: {
                stroke: '#12708D',
              },
            },
            grid: {
              line: {
                style: {
                  stroke: '#12708D',
                  strokeOpacity: 0.4,
                },
              },
            },
            minTickInterval: 50,
            min: 0,
          }}
          areaStyle={{
            fill: 'l(90) 1：#ffffff 0.5:#A9FEF3 0:#02E6CB',
          }}
          tooltip={{
            formatter: (data) => {
              // return {
              //   name: `${data.payModeLabel}`,
              //   value: `${data.bills}笔`,
              // }
              if(lotchangModal){
                return {
                  name: `${data.payModeLabel}`,
                  value: `${data.bills}笔`,
                }
              }else{
                console.log(data);
                return {
                  name: `${data.date}`,
                  value: `${data.billAmount}元`,
                }
              }
              
            },
            showTitle: false,
          }}
          animation={{
            appear: {
              animation: 'path-in',
              duration: 3000,
            },
            enter: {
              easing: 'easeLinear',
              duration: 3000,
              delay: 2000,
            },
          }}
        />
      ) : (
        <div className='fetch_container' style={{ height: 200 }}>
          暂无数据
        </div>
      )}
    </Panel>
  )
}

export default ParkingDailyIncome
